import PropTypes from 'prop-types';

import EducationFieldSet from '../../components/EducationFieldSet';
import useUniqueKeys from '../../hooks/useUniqueKeys';


const RenderEducationFieldSet = ({ fields, validateResume }) => {
  const [onDelete, modFields, setWasDeleted] = useUniqueKeys(fields.value || []);

  const handleFieldDelete = (id, index) => {
    fields.remove(index);
    onDelete(id);
  };

  const handleFieldAdd = () => {
    fields.push({});
    setWasDeleted(false);
  };

  return (
    <>
      {modFields.map(({ id }, index) => (
        <EducationFieldSet
          key={id}
          member={`${fields.name}[${index}]`}
          index={index}
          validateResume={validateResume}
          onDelete={() => handleFieldDelete(id, index)}
        />
      ))}
      <button
        type="button"
        className="button button_plus"
        onClick={handleFieldAdd}
      >
        <span className="button-icon">+</span>
        <span className="button-text">Добавить учебное заведение</span>
      </button>
    </>
  );
};

RenderEducationFieldSet.propTypes = {
  fields: PropTypes.object.isRequired,
  validateResume: PropTypes.func.isRequired,
};

export default RenderEducationFieldSet;
